import React, { useEffect, useState } from "react"
import styled from "styled-components"
import loaderGif from "../images/loader.gif"

// How long the loader stays up per mount. It isn't tied to any real async
// wait (this site's pages are statically generated, so there's nothing to
// actually wait for) — it's a fixed-length branded transition.
const MIN_VISIBLE_MS = 500

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  /* One below the header's z-index (999), so the sticky header stays visible
     and usable on top of the loader instead of being covered by it. */
  z-index: 998;
  background: #edeeee;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`

const LoaderImage = styled.img`
  width: 288px;
  height: 293px;
  object-fit: contain;
`

const PageLoader = () => {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), MIN_VISIBLE_MS)
    return () => clearTimeout(timer)
  }, [])

  if (!visible) return null

  return (
    <Overlay aria-hidden="true">
      <LoaderImage src={loaderGif} alt="" />
    </Overlay>
  )
}

export default PageLoader
